if (!customElements.get('description-show-more')) {
  customElements.define(
    'description-show-more',
    class DescriptionShowMore extends HTMLElement {
      constructor() {
        super();
        this.description = this.querySelector('.product__description');
        this.button = this.querySelector('.product__description-toggle');
        this.label = this.querySelector('.description-toggle-label');
        this.onResize = this.debounce(this.evaluate.bind(this), 150);
      }

      connectedCallback() {
        if (!this.description || !this.button) return;

        this.button.addEventListener('click', this.toggle.bind(this));
        window.addEventListener('resize', this.onResize);

        // Re-evaluate once the page has fully loaded (images in the description
        // can change its height after initial render).
        if (document.readyState === 'complete') {
          this.evaluate();
        } else {
          window.addEventListener('load', this.evaluate.bind(this), { once: true });
          // Also evaluate now so the collapsed state is correct before load.
          this.evaluate();
        }
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
      }

      // Show the toggle only when the collapsed description actually overflows.
      evaluate() {
        const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
        // Measure against the collapsed state.
        if (isExpanded) this.description.classList.add('is-collapsed');

        const overflows = this.description.scrollHeight > this.description.clientHeight + 2;

        if (overflows) {
          this.button.classList.remove('hidden');
          // Preserve an expanded choice across resizes.
          if (isExpanded) this.description.classList.remove('is-collapsed');
        } else {
          // Fits entirely — show full text, no toggle.
          this.description.classList.remove('is-collapsed');
          this.button.classList.add('hidden');
          this.button.setAttribute('aria-expanded', 'false');
          this.label.textContent = 'See more';
        }
      }

      toggle() {
        const expanded = this.description.classList.toggle('is-collapsed') === false;
        this.button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        this.label.textContent = expanded ? 'See less' : 'See more';
      }

      debounce(fn, wait) {
        let timer;
        return (...args) => {
          clearTimeout(timer);
          timer = setTimeout(() => fn.apply(this, args), wait);
        };
      }
    }
  );
}
